import { PureComponent } from 'preact-compat'
// eslint-disable-next-line import/no-internal-modules
import Radio, { RadioGroup } from '@insided/deprecated-preact-components/design-system-components/radio'

export interface ContentHelpfulnessVisibilityProps {
  setIsLoading: (isLoading: boolean) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  publicId: number
}

enum visibilityTypes {
  useDefault = 'Use default',
  enable = 'Enable',
  disable = 'Disable'
}

export interface ContentHelpfulnessVisibilityState {
  contentHelpfulnessType: visibilityTypes
}

export const getContentHelpfulnessStatus = (contentHelpfulnessStatus: boolean | null) => {
  if (typeof contentHelpfulnessStatus === 'boolean') {
    return contentHelpfulnessStatus ? visibilityTypes.enable : visibilityTypes.disable
  }
  return visibilityTypes.useDefault
}

export const getContentHelpfulnessParams = (visibilityType: string) => {
  if (visibilityType === visibilityTypes.enable) {
    return [true, false]
  }
  if (visibilityType === visibilityTypes.disable) {
    return [false, false]
  }
  return [false, true]
}

class ContentHelpfulnessVisibility extends PureComponent<
  ContentHelpfulnessVisibilityProps,
  ContentHelpfulnessVisibilityState
> {
  constructor(props: ContentHelpfulnessVisibilityProps) {
    super(props)
    this.state = {
      contentHelpfulnessType: visibilityTypes.useDefault
    }
    this.onToggleContentHelpfulness = this.onToggleContentHelpfulness.bind(this)
  }

  // TODO: uncomment when doing https://insidedhq.atlassian.net/browse/CAN-1288
  // async componentDidMount() {
  //   const { publicId } = this.props
  //   const contentHelpfulnessStatus = await getContentHelpfulnessVisibility(publicId)
  //   this.setState({ contentHelpfulnessType: getContentHelpfulnessStatus(contentHelpfulnessStatus) })
  // }

  async onToggleContentHelpfulness(contentHelpfulnessType: visibilityTypes) {
    const { setIsLoading, onShowAlert } = this.props
    // TODO: uncomment get and set when doing https://insidedhq.atlassian.net/browse/CAN-1288
    // const [visible, useDefault] = getContentHelpfulnessParams(contentHelpfulnessType)
    setIsLoading(true)
    try {
      // const [visible, useDefault] = getContentHelpfulnessParams(contentHelpfulnessType)
      this.setState({ contentHelpfulnessType })
      // await setContentHelpfulnessVisibility(publicId, visible, useDefault)
    } catch {
      onShowAlert('error')
    }

    setIsLoading(false)
  }

  render() {
    const { contentHelpfulnessType } = this.state

    return (
      <div className='topic-info__details-item'>
        <label>Content helpfulness visibility</label>
        <RadioGroup spacing='L' direction='horizontal'>
          <Radio
            id='use-default'
            value={<div data-qa='content-helpfulness-use-default'>Use default</div>}
            label='use-default'
            name='content-helpfulness-visibility'
            isChecked={contentHelpfulnessType === visibilityTypes.useDefault}
            onChange={async () => await this.onToggleContentHelpfulness(visibilityTypes.useDefault)}
          />
          <Radio
            id='Enable'
            value={<div data-qa='content-helpfulness-enable'>Enable</div>}
            label='enable'
            name='content-helpfulness-visibility'
            isChecked={contentHelpfulnessType === visibilityTypes.enable}
            onChange={async () => await this.onToggleContentHelpfulness(visibilityTypes.enable)}
          />
          <Radio
            id='Disable'
            value={<div data-qa='content-helpfulness-disable'>Disable</div>}
            label='disable'
            name='content-helpfulness-visibility'
            isChecked={contentHelpfulnessType === visibilityTypes.disable}
            onChange={async () => await this.onToggleContentHelpfulness(visibilityTypes.disable)}
          />
        </RadioGroup>
      </div>
    )
  }
}

export default ContentHelpfulnessVisibility
